




















































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import RoleRequest from "@/models/security/roleRequest.model";
import { UserType } from "@/enums/UserType";
import { RowTable } from '@/typings/BRowTable';
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue"
import BaseSelectPerson from '@/components/base/baseSelectPerson/baseSelectPerson.vue';
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";

@Component({
  components: {
    UserBasicInformationComponent, ResearchCenterBasicInformationComponent,BaseSelectResearchCenter,BaseSelectPerson
  }
})

export default class AdminResearchRoleRequestTable extends GenericBTable<RoleRequest> {
  created() {
    this.tableConfig.controller = "RoleRequest/adminResearch/" + this.user.id;

    this.formatColumns();
    this.tableConfig.actions.customTemplate = true;
  }
  researchCenterId = null;
userId= null;
  get user() {
    return this.$store.state.user;
  }
  @Watch("researchCenterId")
  filterByInstitutions(){
    this.tableConfig.whereParams = `researchCenterId eq ${this.researchCenterId}`
    this.tableConfig.reload();
  }
  @Watch("userId")
  filterByUser(){
      this.tableConfig.whereParams = `userId eq ${this.userId}`
      this.tableConfig.reload();
  }
  mounted() {
    this.permissionAccess.view = true;
    this.permissionAccess.write = true;
    this.permissionAccess.managment = true;
    this.permissionAccess.permissionAccessLevel = true;
  }
  add() {
    this.$store.commit("setOpenAddRequesRoleModal", true);
  }

  view(id: number, data: RoleRequest, props: RowTable<RoleRequest>) {
    this.$router.push(`${this.$router.currentRoute.path}/view/${id}`);
  }

  aprove(roleRequest: RoleRequest) {}
  formatColumns() {
    let user = new BTableColumn("user", "table.user", true);
    let userType = new BTableColumn(
      "userTypeDescription",
      "table.userType",
      true
    );

    let researchCenter = new BTableColumn(
      "researchCenter",
      "table.institutions",
      true
    );

    let roleRequestStatus = new BTableColumn(
      "roleRequestStatusDescription",
      "table.roleRequestStatus",
      true
    );

    researchCenter.customTemplate = true;
    user.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
    // researchType.customTemplate = true;
    this.tableConfig.insertColumns(
      user,
      userType,
      researchCenter,
      roleRequestStatus
    );
  }
}
